import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, [page, searchTerm]);

  const fetchUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}users/fetchallusers?page=${page}&limit=10&search=${searchTerm}`
        
      );

      /*setUsers(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);*/

      setUsers(res.data?.data || []);
      setTotalPages(
        Math.max(1, res.data?.totalPages || 1)
      );


      } catch (error) {
        setError(
          error.response?.data?.message ||
          "Failed to load users"
        );

        toast.error("Failed to load users");

        setUsers([]);
        setTotalPages(1);

      } finally {
        setLoading(false);
      }
  };

  const confirmDelete = (id) => {
    setDeleteTargetId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}users/deleteuser/${deleteTargetId}`
      );

      toast.success("User deleted successfully");

      fetchUsers();
      setShowDeleteModal(false);

    } catch (error) {
      toast.error("Failed to delete user");
    }
  };

  return (
    <div>
      <ToastContainer />

      <div className="main-card">
        <div className="toolbar-container">
          <h2 className="page-title">Users Management</h2>

          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              placeholder="Search Username"
              className="search-box"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
            />

            <Link to="/addUser" className="btn-add-primary">
              + Add User
            </Link>
          </div>
        </div>

        <div className="table-header-panel">Users List</div>

        <table className="custom-table">
          <thead>
            <tr>
              <th>SR No.</th>
              <th>ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>User Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  {error}
                </td>
              </tr>
            ) : users.length > 0 ? (
              users.map((user, index) => (
                <tr key={user.userid}>
                  <td>{(page - 1) * 10 + index + 1}</td>
                  <td>{user.userid}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.usertype}</td>
                  <td>{user.status ? "Active" : "Inactive"}</td>

                  <td>
                    <Link
                      to={`/editUser/${user.userid}`}
                      className="btn-action-edit"
                    >
                      Edit
                    </Link>

                    <button
                      onClick={() => confirmDelete(user.userid)}
                      className="btn-action-delete"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                {error || "No users found"}
              </td>
            </tr>
            )}
          </tbody>
        </table>

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            Prev
          </button>

          <select
            value={page}
            onChange={(e) => setPage(Number(e.target.value))}
          >
            {Array.from({ length: totalPages }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                Page {i + 1}
              </option>
            ))}
          </select>

          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete User</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure?</Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}